import {useState, useEffect} from 'react';

/**
 * Hook to get the current screen width
 * Will be useful for responsive design
 */
export const useScreenWidth = () => {
  const [width, setWidth] = useState(() => window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
};
